import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

// import { Dropdown, Option } from "./Dropdown";
import { Form, Button } from "react-bootstrap";
// import Form from "react-bootstrap/Form";
//import { createDevice } from "../services/createDevice";
import Editable from "react-bootstrap-editable";
import axios from "axios";
import { environment } from "../../environment";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Select from "react-select";
import Toggle from "react-toggle";
import { Country, State, City } from "country-state-city";
import {
  CountryDropdown,
  RegionDropdown,
  CountryRegionData,
} from "react-country-region-selector";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { Checkbox, TextareaAutosize, TextField } from "@mui/material";

import { format } from "date-fns";
import NavbarNew from "../Components/NavbarNew";

const MySwal = withReactContent(Swal);

const AdminLeadView = ({ history, match }) => {
  const [dap_users, setUsers] = useState([]);
  // const [users, setUsers] = useState({});
  const [dap_name, setName] = useState("");
  const [dap_date, setDate] = useState("");
  const [dap_email, setEmail] = useState("");
  const [dap_phone, setPhone] = useState("");
  const [dap_dob, setDOB] = useState("");
  const [dap_billable, setBillable] = useState(false);
  const [dap_billable1, setBillable1] = useState(false);
  const [dap_address, setAddress] = useState("");
  const [dap_city, setDapCity] = useState([]);
  const [dap_countries, setDapCountries] = useState("");
  const [dap_states, setDapState] = useState([]);
  const [country, setCountry] = useState("");
  const [zip, setZip] = useState("");
  const [organization, setOrganization] = useState("");
  const [designation, setdesignation] = useState("");
  const [source, setSource] = useState("");
  const [industry, setIndustry] = useState("");
  const [region, setRegion] = useState("");
  const [loading, setLoading] = useState(false);
  const [countrycode, setCountryCode] = useState("");
  const [postcountry, setPostCountry] = useState("");
  const [poststate, setPostState] = useState("");
  const [postcity, setPostCity] = useState("");
  const [emailErrors, setEmailErrors] = useState({});
  const [nameErrors, setNameErrors] = useState({});
  const [phoneErrors, setPhoneErrors] = useState({});
  const [leadExecutiveName, setLeadExecutiveName] = useState("");
  const [leadExecutiveId, setLeadExecutiveId] = useState("");
  const [Package, setPackage] = useState("");
  const dap_user_id = match.params.id;
  const { SearchBar } = Search;
  const [goBackLink, setGoBackLink] = useState("");

  useEffect(() => {
    let id = match.params.id;

    setGoBackLink("/leads");

    console.log(id);

    axios
      .get(environment.dap_url + "crm_api/getLeadsById?id=" + id)
      .then((res) => {
        const dap_users = res.data;
        console.log(res);
        console.log(res.data);
        console.log("hello");
        // setUsers(res.data);
        setEmail(res.data.email);
        setName(res.data.userFirstName + " " + res.data.userLastName);
        setPhone(res.data.phone);
        setAddress(res.data.address);
        setPostCountry(res.data.country);
        setPostState(res.data.state);
        setPostCity(res.data.city);
        setDate(res.data.date);
        setBillable(res.data.isBillable);
        setZip(res.data.zip);
        setOrganization(res.data.organization);
        setdesignation(res.data.designation);
        setSource(res.data.source);
        setIndustry(res.data.industry);
        setPackage(res.data.package);
        if (res.data.details[0]) {
          setLeadExecutiveName(
            res.data.details[0].userFirstName +
              " " +
              res.data.details[0].userLastName
          );
          setLeadExecutiveId(res.data.details[0]._id);
          console.log(res.data.details[0]._id);

          if (localStorage.getItem("isLeadExecutive")) {
            // getFollowUpByLeadId
            axios
              .post(
                environment.dap_url +
                  "crm_api/getFollowUpByLeadExecutiveIdandLeadId",
                {
                  lead_executive_id: res.data.details[0]._id,
                  lead_id: id,
                }
              )
              .then((resp) => {
                // const dap_users = resp.data;
                console.log("res");
                const data = resp.data;
                const sortedData = data.sort(
                  (a, b) =>
                    new Date(b.date).getTime() - new Date(a.date).getTime()
                );
                setUsers(sortedData);
                console.log(sortedData, 22);
                console.log(resp.data.length);
                // setPackageLabel(res.data[res.data.length-1].label)
                // setPackagePrice(res.data[res.data.length-1].package)
              })
              .catch(function (error) {
                MySwal.fire({
                  title: <p>{error.message}</p>,
                  type: "error",
                });
              });
          } else {
            axios
              .get(environment.dap_url + "crm_api/getFollowUpByLeadId?id=" + id)
              .then((resp) => {
                // const dap_users = resp.data;
                console.log("res");
                const data = resp.data;
                const sortedData = data.sort(
                  (a, b) =>
                    new Date(b.date).getTime() - new Date(a.date).getTime()
                );
                setUsers(sortedData);
                console.log(sortedData, 22);
                console.log(resp.data.length);
                // setPackageLabel(res.data[res.data.length-1].label)
                // setPackagePrice(res.data[res.data.length-1].package)
              })
              .catch(function (error) {
                MySwal.fire({
                  title: <p>{error.message}</p>,
                  type: "error",
                });
              });
          }
        }
        // setLoader(false);
      })
      .catch(function (error) {
        MySwal.fire({
          title: <p>{error.message}</p>,
          type: "error",
        });
      });
  }, []);

  let columns;
  if (localStorage.getItem("isLeadExecutive")) {
    columns = [
      {
        dataField: "sl.no",
        text: "#",
        formatter: (cell, row, rowIndex, formatExtraData) => {
          return rowIndex + 1;
        },
        sort: true,
      },
      {
        dataField: "date",
        text: "Date",
        sort: true,
      },
      {
        dataField: "note",
        text: "Note",
        sort: true,
      },
      {
        dataField: "mode",
        text: "Mode",
        sort: true,
      },
      {
        dataField: "createdAt",
        text: "Created At",
        sort: true,
        formatter: (dataField) => {
          // return (
          //   dataField.userFirstName+' '+dataField.userLastName
          // )
          let dateTimeArr = dataField.split("T");
          let dateArr = dateTimeArr[0].split("-");
          let dateFinal = dateArr[2] + "-" + dateArr[1] + "-" + dateArr[0];
          return dateFinal;
        },
      },
    ];
  } else {
    columns = [
      {
        dataField: "sl.no",
        text: "Sl no.",
        formatter: (cell, row, rowIndex, formatExtraData) => {
          return rowIndex + 1;
        },
        sort: true,
      },
      {
        dataField: "date",
        text: "Date",
        sort: true,
      },
      {
        dataField: "note",
        text: "Note",
        sort: true,
      },
      {
        dataField: "mode",
        text: "Mode",
        sort: true,
      },
      {
        dataField: "details[0]",
        text: "Lead Executive",
        sort: true,
        formatter: (dataField) => {
          return dataField.userFirstName + " " + dataField.userLastName;
        },
      },
    ];
  }

  const defaultSorted = [
    {
      dataField: "id",
      order: "dsc",
    },
  ];

  return (
    <>
      <div>
        <div className="container-fluid">
          <NavbarNew />
          <Link to={goBackLink} className="btn btn-light my-3">
            Go Back
          </Link>
        </div>

        <div style={{ marginTop: "2%" }} className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <h4>Lead Details</h4>
                  <table class="table table-bordered">
                    <tbody>
                      <tr>
                        <th scope="row">Name</th>

                        <td>{dap_name}</td>
                      </tr>
                      {/* <tr>
                      <th scope="row">Date</th>
                      <td>{dap_date}</td>
                    </tr> */}
                      <tr>
                        <th scope="row">Organization</th>
                        <td>{organization}</td>
                      </tr>
                      <tr>
                        <th scope="row">Designation</th>
                        <td>{designation}</td>
                      </tr>
                      <tr>
                        <th scope="row">Source</th>
                        <td>{source}</td>
                      </tr>
                      <tr>
                        <th scope="row">Industry</th>
                        <td>{industry}</td>
                      </tr>
                      <tr>
                        <th scope="row">Email</th>
                        <td>{dap_email}</td>
                      </tr>
                      <tr>
                        <th scope="row">Phone</th>
                        <td>{dap_phone}</td>
                      </tr>
                      <tr>
                        <th width="50%" scope="row">
                          Country
                        </th>
                        <td>{postcountry}</td>
                      </tr>
                      <tr>
                        <th scope="row">State</th>
                        <td>{poststate}</td>
                      </tr>
                      <tr>
                        <th scope="row">City</th>
                        <td>{postcity}</td>
                      </tr>
                      <tr>
                        <th scope="row">Address</th>
                        <td>{dap_address}</td>
                      </tr>
                      <tr>
                        <th scope="row">Zip Code</th>
                        <td>{zip}</td>
                      </tr>
                      <tr>
                        <th scope="row">Assigned to</th>
                        <td>{leadExecutiveName}</td>
                      </tr>
                      {Package == undefined ? (
                        ""
                      ) : Package == "" ? (
                        ""
                      ) : (
                        <tr>
                          <th scope="row">Package</th>
                          <td>{Package}</td>
                        </tr>
                      )}
                      <tr>
                        <th scope="row">Billable</th>
                        {dap_billable ? <td>Yes</td> : <td>No</td>}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <h5 className="ml-3">Follow Ups</h5>
                    <div className="col-12">
                      <ToolkitProvider
                        keyField="id"
                        bootstrap4
                        data={dap_users}
                        columns={columns}
                        search
                      >
                        {(props) => (
                          <div>
                            <div className="d-flex align-items-center">
                              <p className="mb-2 mr-2">Search in table:</p>
                              <SearchBar {...props.searchProps} />
                            </div>
                            <BootstrapTable
                              defaultSorted={defaultSorted}
                              // pagination={paginationFactory()}
                              {...props.baseProps}
                              wrapperClasses="table-responsive"
                            />
                          </div>
                        )}
                      </ToolkitProvider>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminLeadView;
